import React from 'react';

const UserDetails = ({ task }) => {
  return (
    <div className="user-details">
      <div className="card user-detail-card">
        <h3 className="user-detail-header">Personal Information</h3>
        <div className="form-group">
          <div className="user-detail-label">Name</div>
          <div className="user-detail-value">{task.name}</div>
        </div>
        
        <div className="form-group">
          <div className="user-detail-label">Phone</div>
          <div className="user-detail-value">{task.phone}</div>
        </div>
      </div>
      
      <div className="card user-detail-card">
        <h3 className="user-detail-header">Call Agenda</h3>
        <div className="form-group">         
          <div className="user-detail-value">{task.checklist}</div>
        </div>
        
        <div className="form-group">
          <div className="user-detail-label">Created At</div>
          <div className="user-detail-value">{task.created_at["$date"]}</div>
        </div>

        <div className="form-group">
          <div className="user-detail-label">Status</div>
          <div className="user-detail-value">{task.status}</div>
        </div>
      </div>
      
      <div className="card user-detail-card">
        <h3 className="user-detail-header">Call Summary</h3>
        <div className="form-group">
            <div className="user-detail-value">{task.summary}</div>
        </div>
        <div className="form-group">
          <div className="user-detail-label">Complete At</div>
          <div className="user-detail-value">{task.updated_at ? task.updated_at["$date"] : ""}</div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;